




















































import Vue from "vue";
import axios from 'axios';
import store, { State as StoreState } from "@/store";

import PaymentForm, { CardFormResult } from "@/parts/util/PaymentForm.vue";
import PaymentDetails from "@/parts/util/PaymentDetails.vue";
import { ErrorResponse } from '@/api/dto/Error';

import { SettlementReviewRequest, SettlementReviewResponse } from "@/api/dto/Review";
import { settlementReview, getCommission } from "@/api/Review";
import { getDeal } from "@/api/Deal";
import { UserProfile } from "@/api/dto/UserProfile";
import { PurchaseType } from "@/api/dto/PurchaseType";

/**
 * リクエスト生成
 */
const toSettlementRequest = (
  /** クレジットカード入力フラグ */
  cardInputFlg: boolean,
  /** クレジットカード入力フォーム値 */
  result: CardFormResult,
  /** 入札 ID */
  tenderUserId: string
): SettlementReviewRequest => {
  if (cardInputFlg) {
    return {
      cardInputFlg,
      ...result.cardForm!,
      cardSaveFlg: result.cardForm!.cardSaveFlg!,
      purchaseType: PurchaseType.Tendered,
      tenderId: tenderUserId,
    };
  } else {
    return {
      cardInputFlg,
      purchaseType: PurchaseType.Tendered,
      tenderId: tenderUserId,
    };
  }
};

export default Vue.extend({
  name: "TenderPayout",
  components: {
    PaymentForm,
    PaymentDetails,
  },
  data() {
    return {
      /** カード選択フラグ */
      cardSelect: false,
      /** 新しいクレジットカードを使用するかどうか */
      cardInputFlg: true,
      /** 取引 ID */
      dealId: "",
      /** 入札ユーザー ID */
      tenderUserId: "",
      /** 受注希望金額 */
      amount: 0,
      /** 確認モーダルの表示フラグ */
      visibleConfirmModal: false,
      // モーダル関係
      modalOpen: false,
      systemCommission: 0,
      settlementCommission: 0,
    };
  },
  created() {
    this.cardSelect = this.loginData.registeredCreditCard;
    this.cardInputFlg = !this.loginData.registeredCreditCard;
    this.dealId = this.$route.params.dealId;
    this.initData();
  },
  async beforeRouteEnter(to, from, next) {
    try {
      // 取引情報取得
      const { purchaseUserId } = await getDeal(to.params.dealId);
      if (purchaseUserId == store.getters.userProfile.userId) {
        // ログインユーザーが依頼作成者本人の場合、当画面表示
        next();
      } else {
        next({ name: "Top" });
      }
    } catch (e) {
      // APIエラー、依頼が存在しない場合
      next({ name: "Top" });
    }
  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
  },
  methods: {
    async settlementModalOpen() {
      this.settlementCommission = 0;
      this.systemCommission = 0;
      var cardToken = '';
      var settlementType = '1'
      if(this.cardInputFlg){
        var result = {} as CardFormResult;
        result = await (this.$refs.paymentForm as any).validation();
        if(result.message) {
          this.$emit('errorToast', result.message);
          return;
        }
        cardToken = result.cardForm!.cardToken
        var settlementType = '2'
      }
      var res = await getCommission({
          settlementType: settlementType,
          amount: this.amount,
          cardToken: cardToken,
      });
      this.settlementCommission = res.settlementCommission;
      this.systemCommission = res.systemCommission;
      this.modalOpen = true;
    },
    modalClose() {
      this.modalOpen = false;
    },
    async initData() {
      // store から選択した入札ユーザーの情報を取得
      const { tenderUserId, amount } = (this.$store.getters as StoreState).selectedTenderUser;
      // store の値がない場合は 入札一覧画面 に遷移
      if (!tenderUserId || !amount) {
        this.toPreviousPage();
        return;
      }
      this.tenderUserId = tenderUserId;
      this.amount = amount;
    },
    /** 取引管理画面へ */
    toDealsManagement() {
      this.$router.push({ name: "DealsManagement" });
    },
    /** 入札一覧画面に移動 */
    toPreviousPage() {
      this.$router.push({ name: "Tender", params: { dealId: this.dealId } });
    },
    /** 確認モーダルの「OK」click ハンドラ */
    onClickOkOnConfirmModal() {
      this.visibleConfirmModal = false;
      // 決済して公開する
      this.handleClickSettlement();
    },
    /** 決済して取引を開始するボタン click ハンドラ */
    async handleClickSettlement() {
      /** カード入力フォームの値 */
      let cardFormResult: CardFormResult = {};
      // 新しいカード情報
      if (this.cardInputFlg) {
        cardFormResult = await (this.$refs.paymentForm as any).validation();
        window.stop();
        if (cardFormResult.message) {
          this.$emit("errorToast", cardFormResult.message);
          return;
        }
      }
      try {
        let settlementReviewResult = {} as SettlementReviewResponse;
        // レビュー決済
        settlementReviewResult = await settlementReview(
          this.dealId as string,
          toSettlementRequest(this.cardInputFlg, cardFormResult, this.tenderUserId)
        );
        // 3Dセキュア認証画面へ（外部）
        window.location.replace(settlementReviewResult.redirectUrl);
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            this.$emit("errorToast", "決済に失敗しました。時間をおいて再度お試しください。");
          } else {
            this.$emit('errorToast', resError.message);
            this.$router.push({ name: "Top" });
          }
        }
      }
    },
  },
});
